<mat-slide-toggle [ngModel]="filter" (ngModelChange)="toggleRemovedObject()" color="primary">
  Show removed files.
</mat-slide-toggle>

<div class="cell-align-right">
  <span class="hint">You can select a maximum of 25 files.</span>
</div>

<mat-table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 status-table uploads-status-table" matSortActive="upload_date"
  matSortDirection="desc">

  <!-- File Name Column -->
  <ng-container matColumnDef="checkbox">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-checkbox"></mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-column-checkbox">
      <input *ngIf="element.upload_state == 'SUCCESS'" style="cursor: pointer" type="checkbox" [id]="element.object_key"
        name="checkbox_file" (click)="$event.stopPropagation()" (change)="updateList(element)"
        [checked]="isFileShared(element)"
        [disabled]="element.malware_scan_status === 'IN_PROGRESS' || element.malware_scan_status === 'THREAT' || element.malware_scan_status === 'ERROR'">
    </mat-cell>
  </ng-container>

  <!-- File Name Column -->
  <ng-container matColumnDef="file_name">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_name"> File Name</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-column-file_name"> {{element.file_name}} </mat-cell>
  </ng-container>

  <!-- File Size Column -->
  <ng-container matColumnDef="file_size">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-file_size"> Size</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-column-file_size"> {{element.file_size | filesize}} </mat-cell>
  </ng-container>

  <!-- Upload Date Column -->
  <ng-container matColumnDef="upload_date">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-upload_date"> Upload Date</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-column-upload_date">
      <ng-container *ngIf="element.upload_date != 'None'">
        {{element.upload_date | date : 'mediumDate'}}
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Deletion Date Column -->
  <ng-container matColumnDef="deletion_date">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-deletion_date"> Deletion Date</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-column-deletion_date">
      <ng-container *ngIf="element.deletion_date != 'None'">
        {{element.deletion_date | date : 'mediumDate'}}
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Malware Scan Status Column -->
  <ng-container matColumnDef="malware_scan_status">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="mat-column-malware_scan_status" 
      matTooltip="All uploaded files are automatically scanned for viruses and malicious content to ensure safe sharing. You can only share or download files that have passed the security check."> 
      Scan
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-column-malware_scan_status">
      <div class="status-container" style="display: flex; justify-content: center; align-items: center; height: 100%;">
        <ng-container *ngIf="element.malware_scan_status === 'IN_PROGRESS'">
            <mat-icon class="status-icon slow-rotate" matTooltip="Scan in progress. The larger the file, the longer the scan may take." style="color: #1976d2;">autorenew</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'OK'">
          <mat-icon class="status-icon success-icon" matTooltip="No threats detected" style="color: green;">verified_user</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'THREAT'">
          <mat-icon class="status-icon error-icon" matTooltip="Threat detected" style="color: red;">warning</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'ERROR'">
          <mat-icon class="status-icon error-icon" matTooltip="Scan error" style="color: red;">error</mat-icon>
        </ng-container>
        <ng-container *ngIf="element.malware_scan_status === 'SCAN_SKIPPED'">
          <mat-icon class="status-icon warning-icon" matTooltip="File scan unavailable (unsupported format). Consider re-uploading to enable scanning." style="color: orange;">info</mat-icon>
        </ng-container>
        <ng-container *ngIf="!element.malware_scan_status || (element.malware_scan_status !== 'IN_PROGRESS' && element.malware_scan_status !== 'OK' && element.malware_scan_status !== 'THREAT' && element.malware_scan_status !== 'ERROR' && element.malware_scan_status !== 'SCAN_SKIPPED')"></ng-container>
      </div>
    </mat-cell>
  </ng-container>

  <!-- BUTTONS COLUMN -->
  <ng-container matColumnDef="buttons">
    <mat-header-cell *matHeaderCellDef class="mat-column-buttons"><!-- No mat-sort-header here --></mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-column-buttons cell-align-right">
      <!-- Single progress bar that transitions smoothly from indeterminate to determinate -->
      <div *ngIf="element.upload_state === 'IN PROGRESS'" style="width: 100%; display: flex; align-items: center; gap: 8px;">
        <mat-progress-bar 
          [mode]="localObjectStateMap[element.object_key]?.progress ? 'determinate' : 'indeterminate'"
          class="custom-progress-bar"
          [value]="localObjectStateMap[element.object_key]?.progress || 0"
          [matTooltip]="localObjectStateMap[element.object_key]?.progress ? getUploadProgressText(element.object_key) : 'Initializing upload...'"
          style="flex: 1;">
        </mat-progress-bar>
        <button class="vlr-outline-btn vlr-icon-btn" matTooltip="Cancel upload" 
                (click)="$event.stopPropagation();cancel(element.object_key)"
                style="margin: 0;">
          <mat-icon style="color: #f44336;">close</mat-icon>
        </button>
      </div>
      
      <button class="vlr-outline-btn vlr-icon-btn" matTooltip="Share this file"
        (click)="$event.stopPropagation();openShareDialog(element)" *ngIf="element.upload_state == 'SUCCESS'"
        [disabled]="checkDeleting(element.object_key) || element.malware_scan_status === 'IN_PROGRESS' || element.malware_scan_status === 'THREAT'">
        <mat-icon fontSet="material-icons-outlined">share</mat-icon>
      </button>
      <!-- Remove the translate button -->
      <!-- <button mat-raised-button color="primary" (click)="goToTranslatePage(file)">Translate</button> -->
      <button class="vlr-outline-btn vlr-icon-btn" matTooltip="Download this file"
        (click)="$event.stopPropagation();download(element.object_key, element.file_name)"
        *ngIf="element.upload_state == 'SUCCESS'"
        [disabled]="checkDeleting(element.object_key) || element.malware_scan_status === 'IN_PROGRESS' || element.malware_scan_status === 'THREAT'">
        <mat-icon fontSet="material-icons-outlined">file_download</mat-icon>
      </button>
      <button class="vlr-outline-btn vlr-icon-btn" matTooltip="Delete this file"
        (click)="$event.stopPropagation();delete(element)" *ngIf="element.upload_state == 'SUCCESS'"
        [disabled]="checkDeleting(element.object_key) || element.malware_scan_status === 'IN_PROGRESS' || element.malware_scan_status === 'THREAT'">
        <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>